
import request from '@/utils/httpRequest'

// 首页-新闻动态
export function ApiWebArticleIndexNews () {
  return request({
    url: request.adornUrl('/web/article/indexNews'),
    method: 'get',
    params: request.adornParams()
  })
}

// 顶置新闻
export function ApiWebArticleTop () {
  return request({
    url: request.adornUrl(`/web/article/top`),
    method: 'get',
    params: request.adornParams()
  })
}

// 最新新闻列表
export function ApiWebArticleNews (data) {
  return request({
    url: request.adornUrl('/web/article/news'),
    method: 'post',
    data: request.adornData(data)
  })
}

// 热门标签top10列表
export function ApiWebArticleHotLabel () {
  return request({
    url: request.adornUrl(`/web/article/hotLabel`),
    method: 'get',
    params: request.adornParams()
  })
}

// 新闻点击top6列表
export function ApiWebArticleTopRead () {
  return request({
    url: request.adornUrl(`/web/article/topRead`),
    method: 'get',
    params: request.adornParams()
  })
}

// 新闻详情
export function ApiWebArticleInfo (id) {
  return request({
    url: request.adornUrl(`/web/article/info/${id}`),
    method: 'get',
    params: request.adornParams()
  })
}

// 新闻顶部背景图
export function ApiWebArticleBg () {
  return request({
    url: request.adornUrl(`/web/article/background`),
    method: 'get',
    params: request.adornParams()
  })
}


// WEBPACK FOOTER //
// ./src/api/news.js